import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ModuleStruct } from 'src/app/shared/services/structs/user/module.struct';
import { WebsocketRoomUtilService } from 'src/app/shared/services/websocket-util/websocket-room-util.service';
import { MenuModuleEnum } from '../menu.module.enum';
import { WebsocketAttendanceUtilService } from 'src/app/shared/services/websocket-util/websocket-attendance-util.service';

@Component({
    selector: 'app-sub-menu',
    templateUrl: './sub-menu.component.html',
    styleUrls: ['./sub-menu.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubMenuComponent implements OnInit {

  constructor(private router: Router, private websocketRoomUtilService: WebsocketRoomUtilService, private websocketAttendanceUtilService: WebsocketAttendanceUtilService,) { }

  @Input() isVisible: boolean;
  @Input() actualMainMenuName: string;
  @Input() listSubMenuStruct: Array<any>;
  @Output() closeSubMenu = new EventEmitter<any>();

  defaultModuleName: string;
  idDefaultModule: number;
  newDefaultModule: ModuleStruct;

  ngOnInit(): void {
  }

  close() {
    this.closeSubMenu.emit();
  }

  redirect(module) {
    if (module.uri != location.pathname) {
      this.websocketRoomUtilService.clearSocket();
      this.websocketAttendanceUtilService.clearSocket(true);
    }
    this.router.navigate([module.uri]);

  }

}
